module.exports = __webpack_public_path__ + "assets/08b5447c1698ec613dee96cccd8e701e.mp4";